module.exports = __webpack_public_path__ + "img/process-icon2.a959263b.png";